module.exports = __webpack_public_path__ + "img/lqsxtou_4.fcaaa689.svg";